<script>
import ActiveExerciseRepsWeight from '@components/exercise/active-exercise-reps-weight.vue';
import CardExerciseEnergyLevel from '@components/cards/card-exercise-energy-level.vue';
import CardExerciseGoal from '@components/cards/card-exercise-goal.vue';
import CardExerciseCircuitReview from '@components/cards/card-exercise-circuit-review.vue';
import CardExerciseOtherFeedback from '@components/cards/card-exercise-other-feedback.vue';
import CardExerciseRest from '@components/cards/card-exercise-rest.vue';
import CardExerciseSatisfaction from '@components/cards/card-exercise-satisfaction.vue';
import Timer from '@components/timer/timer.vue';
import { breakpointsMixin } from '@mixins/breakpointsMixin';
import { counterMixin } from '@mixins/counter-mixin';
import { modalMethods, modalComputed, videoComputed, videoMethods, workoutComputed, workoutMethods } from '@state/helpers';
import _ from 'lodash';

export default {
  mixins: [breakpointsMixin, counterMixin],
  components: {
    ActiveExerciseRepsWeight,
    CardExerciseEnergyLevel,
    CardExerciseGoal,
    CardExerciseCircuitReview,
    CardExerciseOtherFeedback,
    CardExerciseRest,
    CardExerciseSatisfaction,
    Timer,
  },
  props: {
    workout: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      timerWidth: 0,
      isActivelyWorkingOut: true,
      isRestPeriod: false,
      isEndOfExercise: false,
      endOfCircuit: true,
      surveyStep: 1,
      showCircuitReview: false,
      showSurvey: false,
      exerciseInterval: null,
      currentSetExerciseTime: 0,
      remainingCurrentSetExerciseTime: 0,
      isFinalCircuitExerciseSet: false,
      previousExerciseSetDuration: 0,
      previousSet: {},
      exerciseSets: [],
      timerId: null,
      currentCircuitSet: 0,
    };
  },
  computed: {
    ...modalComputed,
    ...videoComputed,
    ...workoutComputed,
    showEndWorkout() {
      return (
        this.currentSetIndex + 1 === this.currentExercise.setDirections.length &&
        this.currentCircuit &&
        this.currentExerciseIndex + 1 === this.currentCircuit.exercises.length &&
        this.currentCircuitIndex + 1 === this.selectedWorkout.programDayWorkout.circuits.length
      );
    },
    videoUrl() {
      return (
        this.currentExercise &&
        this.currentExercise.mediaAssets &&
        this.currentExercise.mediaAssets.coverVideo &&
        this.currentExercise.mediaAssets.coverVideo.url
      );
    },
    isPlaying() {
      return this.videoAction === 'play';
    },
    exerciseTypeClass() {
      return this.isTimedExercise && this.isRepExercise && this.isWeightedExercise
        ? 'reps-time-weight'
        : this.isRepExercise && this.isWeightedExercise
        ? 'reps-weight'
        : this.isRepExercise && this.isWeightedExercise
        ? 'reps-time'
        : this.isTimedExercise && this.isWeightedExercise
        ? 'time-weight'
        : 'time';
    },
    isInactive() {
      return !this.isActivelyWorkingOut || this.showCircuitReview || this.showSurvey;
    },
    currentReps() {
      return this.clientSetDirections &&
        this.clientSetDirections !== null &&
        this.currentSetIndex !== null &&
        this.clientSetDirections.length > 0 &&
        this.clientSetDirections[this.currentSetIndex]
        ? this.clientSetDirections[this.currentSetIndex].clientReps
          ? this.clientSetDirections[this.currentSetIndex].clientReps
          : this.clientSetDirections[this.currentSetIndex].reps
        : 0;
    },
    currentWeight() {
      return this.clientSetDirections &&
        this.clientSetDirections !== null &&
        this.currentSetIndex !== null &&
        this.clientSetDirections.length > 0 &&
        this.clientSetDirections[this.currentSetIndex]
        ? this.clientSetDirections[this.currentSetIndex].clientWeight
          ? this.clientSetDirections[this.currentSetIndex].clientWeight
          : this.clientSetDirections[this.currentSetIndex].weight
        : 0;
    },
    hasSetDirections() {
      return (
        this.currentCircuit &&
        this.currentCircuit.exercises &&
        this.currentCircuit.exercises.length > 0 &&
        this.currentCircuit.exercises[this.currentExerciseIndex] &&
        this.currentCircuit.exercises[this.currentExerciseIndex].setDirections &&
        this.currentCircuit.exercises[this.currentExerciseIndex].setDirections.length > 0
      );
    },
    isTimedExercise() {
      const i = this.currentExerciseIndex;
      const j = this.currentSetIndex;

      return (
        (this.currentExercise &&
          this.currentExercise.setDirections &&
          this.currentExercise.setDirections[j] &&
          this.currentExercise.setDirections[j].time) ||
        (this.currentCircuit &&
          this.currentCircuit.exercises &&
          this.currentCircuit.exercises.length > 0 &&
          this.currentCircuit.exercises[i] &&
          this.currentCircuit.exercises[i].setDirections &&
          this.currentCircuit.exercises[i].setDirections[j] &&
          this.currentCircuit.exercises[i].setDirections[j].time)
      );
    },
    isRepExercise() {
      const i = this.currentExerciseIndex;
      const j = this.currentSetIndex;

      return (
        (this.currentExercise &&
          this.currentExercise.setDirections &&
          this.currentExercise.setDirections[j] &&
          this.currentExercise.setDirections[j].reps) ||
        (this.currentCircuit &&
          this.currentCircuit.exercises &&
          this.currentCircuit.exercises.length > 0 &&
          this.currentCircuit.exercises[i] &&
          this.currentCircuit.exercises[i].setDirections &&
          this.currentCircuit.exercises[i].setDirections[j] &&
          this.currentCircuit.exercises[i].setDirections[j].reps)
      );
    },
    isWeightedExercise() {
      const i = this.currentExerciseIndex;
      const j = this.currentSetIndex;

      return (
        (this.currentExercise &&
          this.currentExercise.setDirections &&
          this.currentExercise.setDirections[j] &&
          this.currentExercise.setDirections[j].weight) ||
        (this.currentCircuit &&
          this.currentCircuit.exercises &&
          this.currentCircuit.exercises.length > 0 &&
          this.currentCircuit.exercises[i] &&
          this.currentCircuit.exercises[i].setDirections &&
          this.currentCircuit.exercises[i].setDirections[j] &&
          this.currentCircuit.exercises[i].setDirections[j].weight)
      );
    },
    hideBackButton() {
      return this.isBeginningOfWorkout || (!this.currentCircuitIndex && !this.currentSetIndex && !this.currentExerciseIndex);
    },
    hasTabataFitnessType() {
      if (this.currentCircuit.fitness_types) {
        return this.currentCircuit.fitness_types.filter((e) => e.label.toLowerCase() === 'tabata').length > 0;
      } else {
        return false;
      }
    },
    isTabata() {
      if (this.hasTabataFitnessType) {
        return this.currentCircuit.tabata || this.hasTabataFitnessType;
      } else {
        return this.currentCircuit.tabata;
      }
    },
  },
  async mounted() {
    // if (!this.$_isDesktopView()) {
    //   this.setShowCircuitIntro(true);
    // }
    await this.detailsWidth();
    window.addEventListener('resize', this.detailsWidth);
    this.onSetClientSetDirections();
    this.setExerciseTimer();
  },
  destroyed() {
    window.removeEventListener('resize', this.detailsWidth);
    clearInterval(this.exerciseInterval);
    this.isFinalCircuitExerciseSet = false;
  },
  methods: {
    ...modalMethods,
    ...videoMethods,
    ...workoutMethods,
    setExerciseTimer() {
      // Clear inerval just in case
      clearInterval(this.exerciseInterval);

      if (this.hasSetDirections) {
        let selectedSet;
        const set = this.currentCircuit.exercises[this.currentExerciseIndex].setDirections[this.currentSetIndex];

        if (!set) {
          const circuits = this.selectedWorkout.programDayWorkout.circuits;
          var circuitIndex = this.currentCircuitIndex - 1 > 0 ? this.currentCircuitIndex - 1 : 0;
          const prevCircuit = circuits[circuitIndex];
          const prevExercise = prevCircuit?.exercises[prevCircuit.exercises.length - 1];
          selectedSet = prevExercise?.setDirections[this.currentSetIndex];
        } else {
          selectedSet = set;
        }

        // Check if it's timed exercise
        if (selectedSet?.time > 0) {
          this.currentSetExerciseTime = selectedSet.time;
          this.remainingCurrentSetExerciseTime = this.currentSetExerciseTime;

          this.exerciseInterval = setInterval(() => {
            // Decrement only if video playing and time is not finished and no rest or transition
            if (!this.isTimerPaused) {
              if (this.remainingCurrentSetExerciseTime > 0 && this.videoAction === 'play' && !this.isTransitionPeriod) {
                this.remainingCurrentSetExerciseTime--;
              }

              // Transition to the next set exercise when time has ended
              if (this.remainingCurrentSetExerciseTime === 0 && !this.showCircuitIntro) {
                this.assignActiveExercise('next');
                clearInterval(this.exerciseInterval);
              }
            }
          }, 1000);
        }
      }
    },
    detailsWidth() {
      if (document.getElementById('details-section')) {
        const detailsWidth = document.getElementById('details-section').clientWidth;
        if (detailsWidth < 350) {
          this.timerWidth = 130;
        }
        if (detailsWidth > 350) {
          this.timerWidth = Math.round(detailsWidth / 2.5);
        }
        if (detailsWidth > 420) {
          this.timerWidth = Math.round(detailsWidth / 3);
        }
        if (detailsWidth > 520) {
          this.timerWidth = Math.round(detailsWidth / 3.8);
        }
      }
    },
    async editModal(type) {
      if (type === 'reps') {
        await this.setConfirmationModalCtx({
          type: 'reps',
          data: {
            value: this.currentReps,
            currentSetIndex: this.currentSetIndex,
          },
        });
        this.$bvModal.show('confirmation-modal');
      }
      if (type === 'weight') {
        await this.setConfirmationModalCtx({
          type: 'weight',
          data: {
            value: this.currentWeight,
            currentSetIndex: this.currentSetIndex,
          },
        });
        this.$bvModal.show('confirmation-modal');
      }
    },
    nextSetTime(exercise) {
      if (exercise && exercise.setDirections && exercise.setDirections.length) {
        const set = exercise.setDirections[this.currentSetIndex];
        return set && set.time > 0 ? `${this.$_getFormattedSeconds(set.time)}` : 0;
      }
    },
    nextSetReps(exercise) {
      if (exercise && exercise.setDirections && exercise.setDirections.length) {
        const set = exercise.setDirections[this.currentSetIndex];
        return set && set.reps ? `${set.reps} Reps` : 0;
      }
    },
    nextSetWeight(exercise) {
      if (exercise && exercise.setDirections && exercise.setDirections.length) {
        const set = exercise.setDirections[this.currentSetIndex];
        return set && set.weight ? `${set.weight} Lbs` : 0;
      }
    },
    startSurvey() {
      this.setForceEndWorkout();
      this.setVideoAction('pause');
      this.isActivelyWorkingOut = false;
      this.showCircuitReview = false;
      this.showSurvey = true;
    },
    async handleUpdateWorkoutProgress(direction, circuitIndex, exerciseIndex) {
      let completedElements, workoutDurationSeconds, nextCircuitIndex;
      const programDayWorkout = this.selectedWorkout.programDayWorkout;
      const circuits = programDayWorkout.circuits;
      const workoutProgress = programDayWorkout.clientInput.workoutProgress;
      const elapsedTime = this.videoDuration - this.remainingVideoTime;

      if (direction === 'next') {
        await this.setCompletedWorkoutElements(this.completedWorkoutElements + 1);
        await this.setCompletedWorkoutDuration(this.completedWorkoutDuration + elapsedTime);
        completedElements = this.completedWorkoutElements;
        workoutDurationSeconds = this.completedWorkoutDuration;

        if (circuitIndex !== null) {
          nextCircuitIndex = circuitIndex < 0 ? 0 : circuitIndex;
        } else {
          nextCircuitIndex =
            this.currentCircuitIndex + 1 < programDayWorkout.circuits.length
              ? this.currentCircuitIndex + 1
              : this.currentCircuitIndex;
        }
      } else if (direction === 'prev') {
        completedElements = this.completedWorkoutElements;
        workoutDurationSeconds = this.completedWorkoutDuration;
      }
      this.previousSet.duration = this.previousExerciseSetDuration + 1;

      if (this.exerciseSets.length === 0 && workoutProgress && workoutProgress.sets) {
        this.exerciseSets = _.cloneDeep(workoutProgress.sets);
      }

      const hasSetIndex = this.exerciseSets.findIndex(
        (s) =>
          s.circuitIteration === this.previousSet.circuitIteration &&
          s.exerciseIteration === this.previousSet.exerciseIteration &&
          s.setIteration === this.previousSet.setIteration
      );
      if (hasSetIndex !== -1) {
        this.exerciseSets[hasSetIndex] = this.previousSet;
      } else {
        this.exerciseSets.push(this.previousSet);
      }
      const tempExerciseIndex = circuits[nextCircuitIndex]
        ? exerciseIndex > circuits[nextCircuitIndex].exercises.length
          ? circuits[nextCircuitIndex].exercises.length - 1
          : exerciseIndex + 1
        : 0;
      workoutDurationSeconds = this.exerciseSets.reduce((sum, current) => sum + current.duration, 0);
      const payload = {
        programDayId: this.workout.programDayId,
        workoutProgress: {
          ...workoutProgress,
          sets: this.exerciseSets,
          completedWorkoutElements: completedElements || this.completedWorkoutElements,
          circuitIndex: nextCircuitIndex ?? 0,
          exerciseIndex: tempExerciseIndex ?? 0,
          workoutDurationSeconds: workoutDurationSeconds || this.completedWorkoutDuration,
        },
        currentExercise: this.currentExercise,
        setDirections: this.clientSetDirections,
        currentExerciseIndex: exerciseIndex,
      };

      this.updateWorkout({ ...payload });
    },
    activateCountdown(type, duration) {
      this.isActivelyWorkingOut = false;
      this.setIsTransitionPeriod(true);
      this.setRestType(type);
      this.setVideoAction('pause');

      if (this.skipRestPeriod) {
        clearTimeout(this.timerId);
      }

      this.timerId = setTimeout(
        () => {
          this.setIsTransitionPeriod(false);
          this.setExerciseTimer();

          if (type === 'circuit') {
            this.showCircuitReview = true;
          } else {
            this.isActivelyWorkingOut = true;
            this.setVideoAction('play');
          }
        },
        duration ? (duration > 1 ? (duration + 1) * 1000 : duration) : 0
      );
    },
    handleRestTime(direction, type) {
      if (direction === 'next' && !this.showCircuitIntro) {
        let set;

        if (this.currentSetIndex === 0 && this.currentExerciseIndex > 0) {
          const setDirections = this.currentCircuit.exercises[this.currentExerciseIndex - 1].setDirections;
          const directionsIndex = setDirections.length > 0 ? setDirections.length - 1 : 0;
          set = setDirections[directionsIndex];
        } else {
          if (this.isFinalCircuitExerciseSet) {
            const exerciseIdx = this.currentCircuit.exercises.length > 0 ? this.currentCircuit.exercises.length - 1 : 0;
            const setDirections = this.currentCircuit.exercises[exerciseIdx].setDirections;
            const directionsIndex = setDirections.length > 0 ? setDirections.length - 1 : 0;
            set = setDirections[directionsIndex];
          } else {
            const setIndex = this.currentSetIndex === 0 ? this.currentSetIndex : this.currentSetIndex - 1;
            set = this.currentExercise.setDirections[setIndex];
          }
        }

        const restTime = set?.clientAfterSetRest || set?.afterSetRest;

        if (restTime !== undefined || restTime !== null) {
          this.setAfterSetRest(restTime);
          this.activateCountdown(type || 'exercise', restTime);
        }
      } else {
        this.activateCountdown(type || 'exercise', 1);
      }
    },
    async handleCircuitOpts(i) {
      await this.setCurrentCircuitIndex(i);
      await this.setCurrentCircuit();
      await this.setPrevCircuit();
      await this.setNextCircuit();
      this.onSetClientSetDirections();
    },
    async handleExerciseOpts(i, exercise) {
      await this.setCurrentExerciseIndex(i < 0 ? 0 : i);
      await this.setCurrentExercise(exercise);
      await this.setNextExercise();
      await this.setPrevExercise();
      this.onSetClientSetDirections();
    },
    async assignActiveExercise(direction) {
      this.previousExerciseSetDuration = this.currentExerciseSetTime;
      this.previousSet = {
        circuitIteration: this.currentCircuitIndex,
        exerciseIteration: this.currentExerciseIndex,
        setIteration: this.currentSetIndex,
        reps: this.currentReps, // nullable integer
        weight: this.currentWeight, // nullable integer in pounds?
        duration: this.previousExerciseSetDuration, // nullable integer in seconds
      };
      if (direction === 'next' && this.showCircuitIntro) {
        this.setShowCircuitIntro(false);
        this.setVideoAction('play');
      } else {
        let i, j;

        if (direction === 'next') {
          i = this.currentSetIndex + 1;
          j = this.currentExerciseIndex + 1;
        } else if (direction === 'prev') {
          i = this.currentSetIndex > 0 ? this.currentSetIndex - 1 : this.currentSetIndex;
          j = 0;
        }

        if (i > 0) {
          if (i === this.currentExercise.setDirections.length) {
            await this.setCurrentSetIndex(0);
          } else {
            await this.setCurrentSetIndex(i);
          }
        } else if (i <= 0) {
          if (i === 0 && this.currentExerciseIndex === 0 && this.currentCircuitIndex === 0) {
            this.setIsBeginningOfWorkout(true);
            await this.setCurrentSetIndex(0);
          } else {
            if (i === 0 && this.currentSetIndex === 1) {
              const setIndex = this.currentCircuit.exercises[0]?.setDirections.length - 1;
              await this.setCurrentSetIndex(setIndex);
            } else {
              await this.setCurrentSetIndex(this.prevExercise.setDirections.length - 1);
            }
          }
        }

        if (direction === 'prev') {
          if (this.showCircuitIntro) {
            this.setShowCircuitIntro(false);
          }

          if (i > 0) {
            if (this.currentExerciseIndex < 0) {
              const exerciseIndex = this.currentCircuit.exercises.length - 1;
              await this.handleExerciseOpts(exerciseIndex, this.currentExercise);
            } else {
              await this.handleExerciseOpts(this.currentExerciseIndex, this.currentExercise);
            }
          } else if (i === 0 && this.currentExerciseIndex > 0) {
            const newCircuitIndex = this.currentCircuitIndex > 0 ? this.currentCircuitIndex : 0;
            await this.handleCircuitOpts(newCircuitIndex);
            await this.handleExerciseOpts(this.currentExerciseIndex - 1);
            this.handleRestTime(direction);
          } else if (i <= 0) {
            const newCircuitIndex = this.currentCircuitIndex > 0 ? this.currentCircuitIndex - 1 : 0;
            await this.handleCircuitOpts(newCircuitIndex);
            const newExeIdex = this.currentCircuit.exercises.length - 1;
            const newExe = this.currentCircuit.exercises[newExeIdex];
            await this.handleExerciseOpts(newExeIdex, newExe);
            this.handleRestTime(direction);
          }
        } else if (direction === 'next') {
          await this.setIsBeginningOfWorkout(false);

          const isFinalExerciseSet = j >= this.currentCircuit.exercises.length && i >= this.currentExercise.setDirections.length;
          const isFinalCircuit = this.currentCircuitIndex + 1 >= this.selectedWorkout.programDayWorkout.circuits.length;
          if (isFinalExerciseSet) {
            this.currentCircuitSet++;
            const isFinalCircuitSet = this.currentCircuit.circuitReps === this.currentCircuitSet;

            if (isFinalExerciseSet && isFinalCircuitSet) {
              this.showCircuitReview = true;
              this.setCurrentExerciseIndex(0);
              this.currentCircuitSet = 0;
            }

            if (isFinalExerciseSet && !isFinalCircuitSet) {
              this.handleExerciseOpts(0);
              this.handleRestTime(direction);
            }

            // If end of circuit, handle rest time before showing circuit review
            if (isFinalExerciseSet && isFinalCircuit && isFinalCircuitSet) {
              this.isFinalCircuitExerciseSet = true;
              this.handleRestTime(direction, 'circuit');
            }
          } else if (i < this.currentExercise.setDirections.length) {
            await this.handleExerciseOpts(this.currentExerciseIndex);
            this.handleRestTime(direction);
          } else {
            await this.handleExerciseOpts(j);
            this.handleUpdateWorkoutProgress(direction, null, j > 0 ? j - 1 : 0);
            this.handleRestTime(direction);
          }
        }
        this.handleUpdateWorkoutProgress(direction, null, j > 0 ? j - 1 : 0);
      }
    },

    assignActiveCircuitNoAsync(direction) {
      this.assignActiveCircuit(direction)
        .then(() => {
          this.setExerciseTimer();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async assignActiveCircuit(direction) {
      const i = direction === 'next' ? this.currentCircuitIndex + 1 : this.currentCircuitIndex - 1;

      await this.handleUpdateWorkoutProgress(direction, i, this.currentExerciseIndex);

      if (
        (direction === 'next' && this.isFinalCircuitExerciseSet) ||
        (direction === 'next' &&
          this.currentSetIndex + 1 === this.currentExercise.setDirections.length &&
          this.currentExerciseIndex + 1 === this.currentCircuit.exercises.length &&
          this.currentCircuitIndex + 1 === this.selectedWorkout.programDayWorkout.circuits.length)
      ) {
        this.setVideoAction('pause');
        this.startSurvey();
      } else {
        this.showCircuitReview = false;
        this.isActivelyWorkingOut = true;
        await this.handleCircuitOpts(i);
        await this.setCurrentSetIndex(0);
        await this.handleExerciseOpts(0);
      }
    },
    onSetClientSetDirections() {
      if (this.currentExercise && this.currentExercise.setDirections && this.currentExercise.setDirections.length) {
        this.setClientSetDirections(this.currentExercise.setDirections);
      }
    },
    handleCompleteWorkout() {
      const programDayWorkout = this.selectedWorkout.programDayWorkout;
      this.completeWorkout({
        programDayId: this.workout.programDayId,
        workoutProgress: {
          completedElements: programDayWorkout.clientInput.workoutProgress.totalCompletedWorkoutElements,
          totalSeconds: programDayWorkout.totalSeconds,
        },
        postWorkoutReview: programDayWorkout.clientInput.postWorkoutReview,
      });
    },
    async handleSurveyStep() {
      if (this.surveyStep === 4) {
        await this.handleCompleteWorkout();
        this.$router.replace({ name: 'home' });
      } else {
        this.surveyStep++;
      }
    },
  },
  watch: {
    currentSetIndex(newVal, oldVal) {
      this.setExerciseTimer();
    },
    showCircuitIntro(newVal, oldVal) {
      if (!newVal) {
        this.setExerciseTimer();
      }
    },
    async skipRestPeriod(newVal, oldVal) {
      if (newVal) {
        await this.activateCountdown('exercise', 0);
        this.setSkipRestPeriod(false);
      }
    },
  },
};
</script>

<template>
  <div
    :class="[
      'exercise-drawer-container',
      {
        mobile: !$_isDesktopView(),
        transitioning: isTransitionPeriod && $_isDesktopView(),
        inactive: isInactive,
        intro: showCircuitIntro && currentExercise && !isEndOfExercise,
        endexercise: isEndOfExercise,
      },
    ]"
  >
    <CardExerciseRest :width="timerWidth" v-if="isTransitionPeriod && !$_isDesktopView()" />

    <div class="is-actively-working-out" v-if="isActivelyWorkingOut && !isTransitionPeriod && !showCircuitReview && !showSurvey">
      <div class="exercise-title" v-if="currentExercise && !$_isDesktopView() && !isEndOfExercise && !showCircuitIntro">
        <span>{{ currentExercise.label }}</span>
      </div>

      <div class="exercise-selector left" v-if="!isEndOfExercise && !showCircuitIntro">
        <div class="row" v-if="$_isDesktopView() && !hideBackButton">
          <div class="col-4 button-wrapper">
            <BaseButton
              :disabled="false"
              class="button btn-primary large-transparent btn-back-desktop"
              @click="assignActiveExercise('prev')"
            >
              <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon-step'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M1.885 6.5l7.077 5.111a.325.325 0 00.355.018.36.36 0 00.134-.137.4.4 0 00.049-.193V.701a.399.399 0 00-.05-.193.36.36 0 00-.133-.138.324.324 0 00-.355.019l-7.077 5.11V.75a.783.783 0 00-.203-.53.666.666 0 00-.49-.22.666.666 0 00-.49.22A.783.783 0 00.5.75v10.5c0 .199.073.39.203.53.13.141.306.22.49.22.183 0 .359-.079.489-.22a.783.783 0 00.203-.53V6.5z" fill="#fff"/></svg>
            </BaseButton>
          </div>
          <div class="col-7 details-wrapper">
            <template>
              <p>Previous:</p>
              <p v-if="prevExercise">{{ prevExercise.label }}</p>
              <p v-if="prevExercise" class="exercise-details">
                <span>
                  <span v-if="nextSetTime(prevExercise)">{{
                    nextSetReps(prevExercise) ||
                    (!nextSetReps(prevExercise) && nextSetWeight(prevExercise)) ||
                    (!nextSetReps(prevExercise) &&
                      !nextSetWeight(prevExercise) &&
                      (prevExercise.requiredEquipment.unweighted.length || prevExercise.requiredEquipment.weighted))
                      ? `${nextSetTime(prevExercise)}・`
                      : nextSetTime(prevExercise)
                  }}</span>
                  <span v-if="nextSetReps(prevExercise)">{{
                    nextSetWeight(prevExercise) ||
                    (!nextSetWeight(prevExercise) &&
                      (prevExercise.requiredEquipment.unweighted.length || prevExercise.requiredEquipment.weighted))
                      ? `${nextSetReps(prevExercise)}・`
                      : nextSetReps(prevExercise)
                  }}</span>
                  <span v-if="nextSetWeight(prevExercise)">{{
                    prevExercise.requiredEquipment.unweighted.length || prevExercise.requiredEquipment.weighted
                      ? `${nextSetWeight(prevExercise)}・`
                      : nextSetWeight(prevExercise)
                  }}</span>
                </span>
                <template v-if="prevExercise.requiredEquipment.unweighted.length">
                  <span v-for="(equipment, i) in prevExercise.requiredEquipment.unweighted" :key="i">
                    {{ equipment.label }}<span v-if="i + 1 < prevExercise.requiredEquipment.unweighted.length">,</span>
                  </span>
                </template>
                <span v-if="prevExercise.requiredEquipment.weighted"> {{ prevExercise.requiredEquipment.weighted.label }} </span>
              </p>
            </template>
          </div>
        </div>
      </div>

      <div id="details-section" class="details-section">
        <div class="circuit-intro-text" v-if="showCircuitIntro && !$_isDesktopView()">
          {{ currentCircuit.trainerFeedback.intro.text }}
        </div>
        <div style="display: grid; width: 25%;" v-if="isTabata">
          <span class="label" style="text-align: center;">Round</span>
          <br />
          <span class="num" style="text-align: center;">{{ currentSetIndex + 1 }}</span>
        </div>

        <template v-if="!showCircuitIntro && !isEndOfExercise">
          <div :class="['active-exercise-metrics-container', exerciseTypeClass]">
            <div class="reps-container" v-if="isRepExercise && !isTabata" @click="editModal('reps')">
              <p class="num">{{ currentReps }} </p>
              <p class="label">REPS <BaseIcon name="arrow-circle-right"/></p>
            </div>
            <ActiveExerciseRepsWeight
              v-if="isRepExercise && !isDesktopView && !currentCircuit.tabata"
              :currentSetIndex="currentSetIndex"
              type="reps"
              :num="currentReps"
            />
            <div class="timer-container" v-if="isTimedExercise">
              <Timer
                :type="'exercise'"
                :diameter="timerWidth"
                :timeRemaining="remainingCurrentSetExerciseTime"
                :originalTime="currentSetExerciseTime"
                :backgroundColor="isTabata ? 'rgba(255, 255, 255, 0.1)' : '#3F3F3F'"
                :startColor="'#FFA9AC'"
                :stopColor="'#C93D42'"
                :lineWidth="12"
                :isClockwise="true"
                :tabata="isTabata"
              />
            </div>
            <ActiveExerciseRepsWeight
              v-if="isWeightedExercise && !isDesktopView && !isTabata"
              :currentSetIndex="currentSetIndex"
              type="weight"
              :num="currentWeight"
            />
            <div class="weight-container" v-if="isWeightedExercise && !isTabata" @click="editModal('weight')">
              <p class="num">{{ currentWeight }} </p>
              <p class="label">LBS <BaseIcon name="arrow-circle-right"/></p>
            </div>
          </div>
        </template>

        <div class="circuit-move-section" v-if="isDesktopView">
          <div class="exercise-progress">
            <p v-if="currentCircuit">
              {{ currentCircuit.label }}
              <span v-if="currentCircuit.circuitReps > 1">
                {{ currentCircuitSet + 1 }} / {{ currentCircuit.circuitReps }} Laps
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="exercise-selector" v-if="!isEndOfExercise">
        <div class="row">
          <div class="col-2 button-wrapper" v-if="!$_isDesktopView() && !hideBackButton && !showCircuitIntro">
            <span @click="assignActiveExercise('prev')">
              <img src="@assets/images/icons/icon-step-backward.svg" class="icon-step left" />
            </span>
          </div>
          <div class="col-7 details-wrapper" v-if="!showCircuitIntro">
            <p>
              <span v-if="nextExercise || isEndOfWorkout">Up Next:</span>
              <span v-if="!nextExercise && !isEndOfWorkout">Next Circuit:</span>
            </p>

            <template v-if="nextExercise && !showEndWorkout">
              <p :class="{ isMobile: !$_isDesktopView() }">{{ nextExercise.label }}</p>
              <p class="exercise-details">
                <span>
                  <span v-if="nextSetTime(nextExercise)">{{
                    nextSetReps(nextExercise) ||
                    (!nextSetReps(nextExercise) && nextSetWeight(nextExercise)) ||
                    (!nextSetReps(nextExercise) &&
                      !nextSetWeight(nextExercise) &&
                      (nextExercise.requiredEquipment.unweighted.length || nextExercise.requiredEquipment.weighted))
                      ? `${nextSetTime(nextExercise)}・`
                      : nextSetTime(nextExercise)
                  }}</span>
                  <span v-if="nextSetReps(nextExercise)">{{
                    nextSetWeight(nextExercise) ||
                    (!nextSetWeight(nextExercise) &&
                      (nextExercise.requiredEquipment.unweighted.length || nextExercise.requiredEquipment.weighted))
                      ? `${nextSetReps(nextExercise)}・`
                      : nextSetReps(nextExercise)
                  }}</span>
                  <span v-if="nextSetWeight(nextExercise)">{{
                    nextExercise.requiredEquipment.unweighted.length || nextExercise.requiredEquipment.weighted
                      ? `${nextSetWeight(nextExercise)}・`
                      : nextSetWeight(nextExercise)
                  }}</span>
                </span>
                <template v-if="nextExercise.requiredEquipment.unweighted.length">
                  <span v-for="(equipment, i) in nextExercise.requiredEquipment.unweighted" :key="i">
                    {{ equipment.label }}
                    <span v-if="i + 1 < nextExercise.requiredEquipment.unweighted.length">,</span>
                  </span>
                </template>
                <span v-if="nextExercise.requiredEquipment.weighted">{{ nextExercise.requiredEquipment.weighted.label }}</span>
              </p>
            </template>

            <template v-if="!nextExercise || showEndWorkout">
              <p v-if="showEndWorkout">End Workout</p>
              <p v-if="!isEndOfWorkout && nextCircuit && !showEndWorkout">{{ nextCircuit.label }}</p>
            </template>
          </div>

          <div class="col-12 text-center" v-if="isTabata && showCircuitIntro">
            <span class="label-intro"
              >GET<br />
              READY</span
            >
          </div>
          <div class="col-12 text-center" v-if="isTabata && showCircuitIntro" style="padding-top: 20px;">
            <BaseButton class="button btn-primary intro large-transparent" @click="assignActiveExercise('next')"
              >START TABATA
            </BaseButton>
          </div>
          <div class="col-4 button-wrapper" v-if="!showCircuitIntro">
            <BaseButton :disabled="false" class="button btn-primary large-transparent" @click="assignActiveExercise('next')">
              <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon-step'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9.635 7.584l-8.257 5.963a.384.384 0 01-.415.021.42.42 0 01-.156-.16.465.465 0 01-.057-.225V.817C.75.738.77.66.807.593A.42.42 0 01.963.432a.379.379 0 01.415.021l8.257 5.963V.875c0-.232.085-.455.236-.619A.778.778 0 0110.442 0c.214 0 .42.092.571.256a.913.913 0 01.237.619v12.25a.913.913 0 01-.237.619.777.777 0 01-.57.256.778.778 0 01-.572-.256.913.913 0 01-.236-.619V7.584z" fill="#fff"/></svg>
            </BaseButton>
          </div>
          <div class="circuit-move-section" v-if="!isDesktopView && !showCircuitIntro">
            <div class="exercise-progress">
              <p v-if="currentCircuit">
                {{ currentCircuit.label }}
                <span v-if="currentCircuit.circuitReps > 1">
                  {{ currentCircuitSet + 1 }} / {{ currentCircuit.circuitReps }} Laps
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="feedback-review" v-if="showCircuitReview">
      <CardExerciseCircuitReview @continue="assignActiveCircuitNoAsync('next')" />
    </div>

    <div class="feedback-survey" v-if="showSurvey">
      <CardExerciseEnergyLevel @next-card="handleSurveyStep" v-if="surveyStep === 1" />
      <CardExerciseGoal @next-card="handleSurveyStep" v-if="surveyStep === 2" />
      <CardExerciseSatisfaction @next-card="handleSurveyStep" v-if="surveyStep === 3" />
      <CardExerciseOtherFeedback @next-card="handleSurveyStep" v-if="surveyStep === 4" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown
// stylelint-disable no-descending-specificity

.label-intro {
  color: white;
  font-family: $roboto;
  font-size: 45px;
  font-style: normal;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 65px;
  text-align: center;
  text-transform: uppercase;
  -webkit-transition-duration: 0.3s;
}
.exercise-drawer-container {
  background: #1c1c1c;
  border-top-left-radius: 3.2rem;
  border-top-right-radius: 3.2rem;
  margin-top: auto;
  min-height: 56vh;
  padding-bottom: 2rem;
  padding-top: 2rem;
  position: relative;
  width: 100%;

  @include media('xxl', null) {
    background: rgba(#1c1c1c, 0.4);
    border-radius: 3.2rem;
    margin-bottom: 2.5%;
    margin-top: auto;
    min-height: 18rem;
    padding-bottom: 2rem;
    padding-top: 2rem;
    position: relative;
    width: 93%;
  }

  .is-actively-working-out {
    display: block;
    height: 100%;
    width: 100%;
    @include media('xxl', null) {
      align-items: center;
      display: grid;
      grid-column-end: 3;
      grid-column-start: 1;
      grid-row-end: 1;
      grid-row-start: 1;
      grid-template-columns: repeat(3, 1fr);
    }

    .exercise-title {
      @include calc-font-size(1.5);

      background-color: #252526;
      border: 4px solid black;
      border-radius: 3.2rem;
      color: white;
      font-weight: bold;
      line-height: 2.6rem;
      margin: 0 auto 2.8rem;
      padding: 0.2rem 1rem;
      text-align: center;
      text-transform: capitalize;
      width: 90%;
    }

    .details-section {
      justify-self: center;
      width: 100%;

      .circuit-intro-text {
        @include calc-font-size(2.4);

        align-items: center;
        color: white;
        display: flex;
        font-style: normal;
        font-weight: 600;
        line-height: 2.6rem;
        margin-bottom: 3rem;
        padding: 0.2rem 2rem;
        text-align: center;
      }

      p {
        text-align: center;
      }

      .reps-container,
      .weight-container {
        display: none;

        @include media('xxl', null) {
          display: block;
        }
      }

      .circuit-move-section {
        @include calc-font-size(1.5);

        align-items: center;
        bottom: -6.5rem;
        color: white;
        display: flex;
        font-family: $roboto;
        font-style: normal;
        font-weight: 500;
        justify-content: center;
        line-height: 2.3rem;
        .exercise-progress {
          margin-left: 2rem;
          margin-right: 2rem;

          p {
            @include calc-font-size(1.1);

            color: rgba(white, 0.8);
            margin-bottom: 0;
          }
        }

        svg {
          -webkit-transition-duration: 0.3s;

          &:hover {
            color: darken(white, 10);
            cursor: pointer;
          }
        }
      }

      .active-exercise-metrics-container {
        align-items: center;
        display: flex;
        justify-content: space-evenly;

        .reps-container,
        .weight-container {
          .num {
            color: white;
            font-family: $base-font-family;
            font-size: 44px;
            font-style: normal;
            font-weight: 800;
            line-height: 60px;
            margin-bottom: unset;
            text-transform: uppercase;

            @media screen and (min-width: 1100px) {
              @include calc-font-size(5.7);
            }
          }

          .label {
            color: white;
            font-family: $roboto;
            font-size: 15px;
            font-style: normal;
            font-weight: bold;
            letter-spacing: 0.5px;
            line-height: 18px;
            text-transform: uppercase;
            -webkit-transition-duration: 0.3s;

            @media screen and (min-width: 1100px) {
              @include calc-font-size(1.2);
            }
          }
          &:hover {
            cursor: pointer;
            .num,
            .label {
              color: darken(white, 10);
            }
          }
        }
      }
    }

    .exercise-selector {
      bottom: 0;
      justify-self: flex-end;
      min-width: 100%;
      padding-right: 2rem;
      position: relative;
      width: 100%;

      @include media('xxl', null) {
        position: unset;
      }

      .row {
        align-items: center;
        display: flex;
        justify-content: flex-end;
        margin-left: unset;
        margin-right: unset;
        width: 100%;

        .details-wrapper {
          width: fit-content;
          .exercise-details {
            align-items: center;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: flex-start;
          }
          p {
            margin-bottom: 0.5rem;
            margin-left: auto;
            margin-right: auto;

            &:first-child {
              color: white;
              font-family: $proxima-nova;
              font-size: 12px;
              font-style: normal;
              font-weight: 600;
              line-height: 15px;

              @media screen and (min-width: 1100px) {
                @include calc-font-size(0.8);
              }
            }

            &:nth-child(2) {
              color: white;
              font-family: $roboto;
              font-size: 15px;
              font-style: normal;
              font-weight: bold;
              letter-spacing: 0.5px;
              line-height: 18px;
              overflow: hidden;
              position: relative;
              &.isMobile {
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              @media screen and (min-width: 1100px) {
                @include calc-font-size(1);
              }
            }

            &:nth-child(3) {
              color: #f2f2f2;
              font-family: $proxima-nova;
              font-size: 14px;
              font-style: normal;
              font-weight: 300;
              line-height: 17px;
              mix-blend-mode: normal;
              opacity: 0.7;
              text-transform: capitalize;

              @media screen and (min-width: 1100px) {
                @include calc-font-size(1);
              }
            }
          }
        }

        .button-wrapper {
          align-items: center;
          display: flex;
          justify-content: center;
          max-width: fit-content;
          position: relative;
          width: fit-content;

          .btn-primary {
            align-items: center;
            border-radius: 50%;
            display: flex;
            height: 6.2rem;
            justify-content: center;
            position: relative;
            width: 6.2rem;

            &.btn-back-desktop {
              background-color: transparent;
              border-color: transparent;
            }

            .icon-step {
              height: 2.1rem;
              position: relative;
              width: 2.1rem;
              z-index: 10;

              path {
                width: 2.1rem;
              }
            }

            &:disabled {
              background: unset;
              border: unset;
              border-color: unset;
            }
          }
        }
      }
      &.left {
        padding-left: unset;
        padding-right: unset;
        .row {
          justify-content: flex-start;
        }
      }
    }
  }

  &.inactive,
  &.transitioning {
    background: transparent;
    min-height: 75vh;
    @include media('xxl', null) {
      width: 60%;
    }
  }

  &.inactive {
    background: rgba(#1c1c1c, 0.8);
    overflow-y: scroll;
  }

  &.transitioning {
    background: rgba(255, 255, 255, 0);
  }

  &:not(.inactive) {
    &:not(.transitioning) {
      &:not(.mobile) {
        align-items: center;
        display: flex;
        justify-content: center;
      }
    }
  }

  .feedback {
    height: 100%;
  }

  .feedback-review {
    height: 100%;
  }

  &.mobile {
    &.transitioning {
      background: #1c1c1c;
    }

    &.inactive {
      background: #1c1c1c;
      .feedback-review {
        height: 100%;
        margin: 7rem 0 8rem;
        @include media('md', null) {
          margin: 3rem 0 8rem;
        }
      }

      .feedback-survey {
        margin: 6rem 0 8rem;
      }
    }

    .is-actively-working-out {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      .active-exercise-metrics-container {
        .timer-container {
          align-items: center;
          display: flex;
          flex: 1;
          justify-content: center;
        }

        .active-exercise-metric {
          flex: 1;
        }

        &.reps-time-weight ::v-deep .active-exercise-metric h2 {
          @include calc-font-size(4.5);
        }

        &.reps-weight ::v-deep .active-exercise-metric h2 {
          @include calc-font-size(7.5);
        }

        &.reps-time ::v-deep .active-exercise-metric h2 {
          @include calc-font-size(6.5);
        }

        &.time-weight ::v-deep .active-exercise-metric h2 {
          @include calc-font-size(6.5);
        }

        &.time {
          .timer-container {
            flex: unset;
          }

          ::v-deep .active-exercise-metric h2 {
            @include calc-font-size(6.5);
          }
        }
      }

      .circuit-move-section {
        bottom: -7.3rem;
        display: flex;
        justify-content: space-around;
        position: relative;

        @include media('md', 'iphone-x') {
          bottom: -9rem;
        }

        @include media('lg', 'iphone-6-plus') {
          bottom: -7rem;
        }

        @include media('xl', null) {
          bottom: -14.3rem;
        }

        .backward-wrapper,
        .forward-wrapper {
          align-items: center;
          background-color: $color-action;
          display: flex;
          flex: 0.5;
          height: 2.4rem;
        }

        .backward-wrapper {
          border-bottom-right-radius: 2.4rem;
          border-top-right-radius: 2.4rem;
          justify-content: flex-end;
          padding-right: 1rem;
        }

        .exercise-progress {
          flex: 3;
          overflow: hidden;
          position: relative;

          p {
            position: relative;
            z-index: 1;
          }
        }

        .forward-wrapper {
          border-bottom-left-radius: 2.4rem;
          border-top-left-radius: 2.4rem;
          justify-content: flex-start;
          padding-left: 1rem;
        }
      }

      .exercise-selector {
        margin-top: 20px;
        padding-right: unset;
        .row {
          align-items: center;
          display: flex;
          justify-content: space-between;
          .col-2 {
            margin-left: 1rem;
          }
        }
        @include media('xl', null) {
          bottom: 0;
        }

        &.left {
          margin-top: unset;
          .btn-primary {
            background: rgba(255, 255, 255, 0);
            border: 0;
          }

          .details-wrapper {
            display: none;
          }
        }
        .circuit-move-section {
          bottom: unset;
          margin-left: auto;
          margin-right: auto;
          top: 5px;
          .exercise-progress p {
            color: white;
          }
        }
      }
    }
  }
}

.tabata-circuit {
  .exercise-drawer-container {
    &:not(.inactive) {
      background: #07b903;
    }
    .exercise-title {
      background-color: rgb(0 0 0 / 20%) !important;
      border: 4px solid rgb(71 71 71 / 27%) !important;
    }
    &.intro {
      background: #e12128;
      .exercise-title {
        background-color: rgb(0 0 0 / 20%) !important;
        border: 4px solid rgb(71 71 71 / 27%) !important;
      }
      .btn-primary.intro {
        background: #fff !important;
        border-color: #fff !important;
        border-radius: 38px;
        color: #e12128;
        font-family: 'Roboto', sans-serif;
        font-size: 17px;
        font-weight: 700;
        height: 56px;
        line-height: 28px;
        padding: 0 32px !important;
        width: initial;
      }
    }
    &.mobile {
      &.inactive {
        background: #e12128;
      }
      .details-wrapper {
        align-items: center;
        flex: 100%;
        justify-content: center;
        margin: auto;
        text-align: center;
        .exercise-details {
          justify-content: center !important;
        }
      }
    }
    &.inactive {
      overflow: hidden;
    }
  }
  .rest-wrapper {
    background: #e12128;
  }
}

.num {
  color: white;
  font-family: $base-font-family;
  font-family: 'Roboto', serif;
  font-size: 40px;
  font-style: normal;
  font-weight: bold;
  line-height: 3.5rem;
  margin-bottom: unset;
  margin-bottom: 0;
  text-align: center;
  text-transform: uppercase;

  @media screen and (min-width: 1100px) {
    @include calc-font-size(5.7);
  }
}

.label {
  color: white;
  font-family: 'Roboto', serif;
  font-size: 15px;
  font-style: normal;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 18px;
  text-align: center;
  text-transform: uppercase;

  @media screen and (min-width: 1100px) {
    @include calc-font-size(1.2);
  }
}
</style>
